import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  route: string;
}

export default function PageTransition({
  children,
  route,
}: PageTransitionProps) {
  const pageVariants = {
    initial: {
      opacity: 0,
      y: 10,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1],
      },
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <AnimatePresence mode='wait' initial={false}>
      <motion.div
        key={route}
        initial='initial'
        animate='animate'
        exit='exit'
        variants={pageVariants}
        className='no-scrollbar w-full h-full relative overflow-x-hidden'
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
